export default __webpack_public_path__ + "static/media/pad-speaker.fb120b6b.svg";